import {
  updateContactReleaseToAIL,
  getTransferEndpoints,
  getContactEventLoggingAPIHandler,
  CURRENT_DOMAIN,
  getMiloDeeplink,
} from "../api/session-api";
import Emitter from "../emitter";
import storeRTK from "../store/storeRTK";
import { SessionEvent } from "../types/call.type";
import { setCurrentSessionTab } from "../actions/session";
import { addVoicemailToHistoryAction } from "../connector/history";
import { CASE_STATES } from "../constants/constants";
import { setSelectedTab } from "../actions/common";
import {
  API_CALLBACK_UPDATE,
  API_MILO_VOICEMAIL_CHANNEL_TRANSACTION,
  STATE_VOICEMAIL,
  STATE_MISSED_VOICEMAIL,
} from "../constants/events";
import {
  setMediaPlaybackUrl,
  updateNormalvoicemail,
  voicemailReset,
} from "../actions/voicemail";
import { notificationManager } from "../utils/NotificationManager";
import { addNotificationAction } from "../connector/notifications";
import { createMissedVoicemailNotification } from "../actions/notifications";
import { showErrorToast } from "../utils/utils";
import { voicemailPlayer } from "../amazon-connect/handlers/voicemail";

function voicemailHandler(event: SessionEvent<any>) {
  if (event.body?.self?.voicemail?.state) {
    if (event.body?.self?.voicemail?.state === CASE_STATES.RINGING) {
      getContactEventLoggingAPIHandler(event?.body?.id ?? "", "RINGING");
    }
    if (event.body?.self?.voicemail?.state === CASE_STATES.RELEASED) {
      const cstate = storeRTK.getState();
      if (cstate.voicemail?.id === event.body?.id) {
        storeRTK.dispatch(addVoicemailToHistoryAction(event.body));
        storeRTK.dispatch(voicemailReset());
        notificationManager.stopFaviconBlinking();
      }
      updateContactReleaseToAIL("voicemail", event.body?.id as string);
    } else if (event.body?.self?.voicemail?.state === "TERMINATED") {
      storeRTK.dispatch(voicemailReset());
      notificationManager.stopFaviconBlinking();
    } else if (event.body) {
      //TODO: Find better solution for this
      if (event.body.selfState !== CASE_STATES.ESTABLISHED) {
        storeRTK.dispatch(setCurrentSessionTab({ id: "voicemail" }));
        storeRTK.dispatch(setSelectedTab("Voicemail"));
      }

      const cstate = storeRTK.getState();
      const voicemailNotPresent = !cstate.voicemail.id;
      storeRTK.dispatch(updateNormalvoicemail(event.body));

      if (
        cstate.voicemail.id &&
        event.body?.self?.voicemail?.state === "ESTABLISHED" &&
        !cstate.voicemail.playbackMediaURL
      ) {
        let playbackMediaURL = `${CURRENT_DOMAIN}/v1/session/agent/web/getVoicemailRecording/${
          event.body.id as string
        }`;
        storeRTK.dispatch(setMediaPlaybackUrl(playbackMediaURL));
      }
      const state = storeRTK.getState();

      if (voicemailNotPresent) {
        if (event.body?.self?.voicemail?.state === CASE_STATES.RINGING) {
          notificationManager.startFaviconBlinking();
          const voicemail = state.voicemail;
          notificationManager.show("You have an incoming voicemail", {
            body: "Click or open iHub to answer it",
            icon: "icon.png",
            onclick: () => {
              Emitter.emit(API_CALLBACK_UPDATE, {
                body: {
                  participantId: voicemail.self?.id,
                  conversationId: voicemail?.id,
                  state: "connected",
                },
              });
            },
          });
        }
      } else {
        if (state.voicemail.self?.voicemail?.state != "RINGING") {
          notificationManager.stopFaviconBlinking();
        }
      }
    }
  }
}

async function contactEstablished(contactId: string | undefined) {
  if (contactId) {
    try {
      getTransferEndpoints(contactId);
    } catch (e: any) {
      console.log(
        "Error getting contact Established API during channel voicemail",
        e.message
      );
    }
  } else {
    console.log("Error: error in setting transfer endpoints");
  }
}

async function miloHandlerEvent(ev: SessionEvent<any>) {
  const miloEvent = {
    body: {
      contactId: ev.body.contactId,
    },
  };
  notificationManager.triggerMilo(miloEvent, "voicemail");
}

// Milo redirect to CRM
export async function miloHandlerForVoicemail(
  ev: SessionEvent<{ contactId: string | undefined }>
) {
  contactEstablished(ev.body?.contactId);
  const miloDeeplink = await getMiloDeeplink("voicemail", ev.body?.contactId);
  if (miloDeeplink) {
    setTimeout(() => {
      window.open(miloDeeplink, "_blank");
    }, 100);
  }
}

// async function loggingHandlerEvent(ev: SessionEvent<any>) {
//   const loggingEvent = {
//     body: {
//       contactId: ev.body?.contactId,
//       eventType: ev.body?.eventType,
//     },
//   };
//   notificationManager.eventLoggingAPI(loggingEvent, "voicemail");
// }

const missedVoicemailHandlerEvent = (ev: SessionEvent<any>) => {
  console.log("Missed voicemail event: ", ev);
  
  const eventData = ev.body;
  
  // Create missed voicemail notification
  const notification = createMissedVoicemailNotification(
    eventData.contactId,
    eventData.customerName,
    eventData.phoneNumber,
    eventData.voicemailDuration
  );
  
  // Dispatch the notification to the Redux store
  storeRTK.dispatch(addNotificationAction(notification));

  // Also display a persistent toast notification
  showErrorToast("You have missed a voicemail from " + eventData.phoneNumber, "missedVoicemailNotification", 1*60*60*1000); // 1 hour
};

export default function registerVoicemailHandlers() {
  Emitter.on(STATE_VOICEMAIL, voicemailHandler);
  Emitter.on(API_MILO_VOICEMAIL_CHANNEL_TRANSACTION, miloHandlerEvent);
  // Emitter.on(API_CONTACT_EVENT_LOGGING_VOICEMAIL, loggingHandlerEvent);
  Emitter.on(STATE_MISSED_VOICEMAIL, missedVoicemailHandlerEvent); // For missed voicemail notification
}
